module.exports = __webpack_public_path__ + "static/media/OTAYStill.15e0ed5f.jpg";